import { render } from "./MyFooterB.vue?vue&type=template&id=660c11d2&scoped=true"
const script = {}

import "./MyFooterB.vue?vue&type=style&index=0&id=660c11d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660c11d2"]])

export default __exports__